import React from 'react';
import Header from 'View/Component/Header/Header';
import PartnerStrip from 'View/Component/PartnerStrip/PartnerStrip';
import HeroSlider from 'View/Component/HeroSlider/HeroSlider';
import LatestWatchesSlider from 'View/Component/LatestWatchesSlider/LatestWatchesSlider';
import InfoGrid from 'View/Component/InfoGrid/InfoGrid';
import Footer from 'View/Component/Footer/Footer';
import { Container } from './HomePage.style';

const HomePage: React.FC = () => {
  return (
    <Container>
      <Header />
      <HeroSlider />
      <LatestWatchesSlider />
      <InfoGrid />
      <PartnerStrip />
      <Footer />
    </Container>
  );
};

export default HomePage;
